import React from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'
import { kFormatter } from 'helpers/formatters'

import classes from './NumberLink.module.scss'

const noop = () => {}

/** @type {import("./types").default} */
const NumberLink = ({ className, value = 0, href, onClick = noop, variant = 'tight-xxs' }) => {
  const formattedValue = `(${kFormatter(value)})`

  const WithLinkTyphography = () =>
    href ? (
      <Typography
        component="a"
        className={clsx(classes.root, classes.link, className)}
        onClick={onClick}
        href={href}
        target="_blank"
        variant={variant}
      >
        {formattedValue}
      </Typography>
    ) : (
      <Typography component="span" className={clsx(classes.root, classes.noLink, className)} variant={variant}>
        {formattedValue}
      </Typography>
    )
  return (
    <>
      {value > 0 ? (
        <WithLinkTyphography />
      ) : (
        <Typography component="span" className={clsx(classes.root, classes.zeroValue, className)} variant={variant}>
          {formattedValue}
        </Typography>
      )}
    </>
  )
}

export default NumberLink
